import { useLoginPage } from '../hooks/useLoginPage';

export function LoginPage() {
  useLoginPage();

  return null;
}
